export const SETTINGS = '/users/settings'
export const CHANGE_PASSWORD = '/users/settings/password'
// SETUP_MFA_ENFORCED moved to the login app (AUTHN-3512) — see constants/links.js.
export const SETUP_MFA = '/users/settings/mfa/setup'
export const SETUP_WEB_AUTHN = '/users/settings/mfa/setup/webauthn'
export const SETUP_TOTP = '/users/settings/mfa/setup/totp'
export const DISABLE_MFA = '/users/settings/mfa/disable'
